export const ADD_IS_LOADED = "LOG_WEIGHT:ADD_IS_LOADED";
export const ADD_IS_SENDING = "LOG_WEIGHT:ADD_IS_SENDING";
export const ADD_CURRENT_WEEK_IS_LOGGED = "LOG_WEIGHT:ADD_CURRENT_WEEK_IS_LOGGED";
export const ADD_LOG_WEIGHT_LIST = "LOG_WEIGHT:ADD_LOG_WEIGHT_LIST";
export const UPDATE_LOG_WEIGHT_LIST = "LOG_WEIGHT:UPDATE_LOG_WEIGHT_LIST";